import { ReportFilter } from './reports'
import { getReport } from './reports'
import { getDataset, DatasetField } from './datasets'

export interface FilterPreset {
  id: string
  /** The report these filters apply to. */
  reportId: string
  name: string
  filters: ReportFilter[]
  /** Seed presets are curated by SureHire; user presets are personal. */
  system?: boolean
}

/**
 * Fields that can be prompted for at run time. We surface string and date
 * fields (the ones people actually filter on), keeping the curated feel of the
 * rest of the app rather than exposing every column as a free-form filter.
 */
export function filterableFields(reportId: string): DatasetField[] {
  const report = getReport(reportId)
  if (!report) return []
  const dataset = getDataset(report.config.datasetId)
  if (!dataset) return []
  return dataset.fields.filter((f) => f.type === 'string' || f.type === 'date')
}

export const seedFilterPresets: FilterPreset[] = [
  {
    id: 'fp-edmonton-appts',
    reportId: 'master-appointments',
    name: 'Edmonton Site',
    system: true,
    filters: [
      { field: 'collectionSite', operator: 'contains', value: 'Edmonton' },
    ],
  },
  {
    id: 'fp-calgary-appts',
    reportId: 'master-appointments',
    name: 'Calgary Site',
    system: true,
    filters: [
      { field: 'collectionSite', operator: 'contains', value: 'Calgary' },
    ],
  },
  {
    id: 'fp-appt-noshows',
    reportId: 'master-appointments',
    name: 'No-Shows Only',
    system: true,
    filters: [{ field: 'status', operator: 'equals', value: 'No Show' }],
  },
  {
    id: 'fp-results-edmonton',
    reportId: 'master-results',
    name: 'Edmonton Lab (DynaLIFE)',
    system: true,
    filters: [{ field: 'lab', operator: 'contains', value: 'Edmonton' }],
  },
  {
    id: 'fp-results-nonneg',
    reportId: 'master-results',
    name: 'Non-Negative Results',
    system: true,
    filters: [{ field: 'result', operator: 'equals', value: 'Non-Negative' }],
  },
  {
    id: 'fp-results-northbridge',
    reportId: 'master-results',
    name: 'Northbridge Energy',
    system: true,
    filters: [{ field: 'company', operator: 'contains', value: 'Northbridge' }],
  },
  {
    id: 'fp-clearance-preaccess',
    reportId: 'clearance-master',
    name: 'Pre-Access Clearances',
    system: true,
    filters: [
      { field: 'clearanceType', operator: 'equals', value: 'Pre-Access' },
    ],
  },
  {
    id: 'fp-clearance-pending',
    reportId: 'clearance-master',
    name: 'Pending Only',
    system: true,
    filters: [{ field: 'status', operator: 'equals', value: 'Pending' }],
  },
]
